/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  EstimationItemResourceResponse,
  UpsertEstimationItemResourceRequest,
  V1EstimationItemsResourcesListError,
  V1EstimationItemsResourcesUpdateError,
  V1EstimationsResourcesListError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EstimationItemResource<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags EstimationItemResource
   * @name V1EstimationsResourcesList
   * @request GET:/api/v1/estimations/{estimationId}/resources
   * @secure
   * @response `200` `(EstimationItemResourceResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsResourcesList = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemResourceResponse[], V1EstimationsResourcesListError>({
      path: `/api/v1/estimations/${estimationId}/resources`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItemResource
   * @name V1EstimationItemsResourcesList
   * @request GET:/api/v1/estimation-items/{estimationItemId}/resources
   * @secure
   * @response `200` `(EstimationItemResourceResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsResourcesList = (estimationItemId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemResourceResponse[], V1EstimationItemsResourcesListError>({
      path: `/api/v1/estimation-items/${estimationItemId}/resources`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItemResource
   * @name V1EstimationItemsResourcesUpdate
   * @summary Updates or creates all estimation item resources of estimation item.
   * @request PUT:/api/v1/estimation-items/{estimationItemId}/resources
   * @secure
   * @response `200` `(EstimationItemResourceResponse)[]` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsResourcesUpdate = (
    estimationItemId: string,
    data: UpsertEstimationItemResourceRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationItemResourceResponse[], V1EstimationItemsResourcesUpdateError>({
      path: `/api/v1/estimation-items/${estimationItemId}/resources`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
